import { ForeignCurrencySettingsDetail } from '@/features/foreign_currency_settings/Detail';

const ForeignCurrencySettingsDetailPage = () => {
  return <ForeignCurrencySettingsDetail />;
};
export default ForeignCurrencySettingsDetailPage;
